export default "__VITE_ASSET__564c698e__"